import { useState } from "react";
import { ChevronDown, X } from "lucide-react";
import { Button } from "../ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { GroupedNavigation } from "./GroupedNavigation";

export const WorkspaceNavigation = ({ groups, pathname, scope, title }) => {
  const [openGroup, setOpenGroup] = useState(null);
  return <nav className="workspace-navigation-toolbar" aria-label={title} data-testid={`${scope}-navigation`}>
    <p className="workspace-navigation-title" data-testid={`${scope}-title`}>{title}</p>
    <div className="workspace-navigation-sections">
      {groups.map(group => {
        const active = group.items.some(item => item.path === pathname);
        return <Popover key={group.id} open={openGroup === group.id} onOpenChange={open => setOpenGroup(open ? group.id : null)}>
          <PopoverTrigger asChild>
            <button type="button" className={`workspace-section-trigger${active ? " is-current" : ""}`} data-testid={`${scope}-${group.id}-button`}>
              <span>{group.label}</span><ChevronDown className="h-4 w-4 shrink-0" aria-hidden="true" />
            </button>
          </PopoverTrigger>
          <PopoverContent align="start" collisionPadding={12} sideOffset={8} className="workspace-navigation-popover" data-testid={`${scope}-${group.id}-menu`}>
            <Button variant="ghost" size="icon" className="workspace-navigation-close" onClick={() => setOpenGroup(null)} aria-label={`Close ${group.label} navigation`} data-testid={`${scope}-${group.id}-close`}><X className="h-4 w-4" /></Button>
            <GroupedNavigation groups={[group]} pathname={pathname} scope={scope} onNavigate={() => setOpenGroup(null)} exact />
          </PopoverContent>
        </Popover>;
      })}
    </div>
  </nav>;
};